import { VISIT_STATUS_LABELS, type UserColor, type VisitDto } from '@kominiarz/shared';
import { Ban, Check } from 'lucide-react';
import { local, timeRange } from '../lib/calendarDates';
import { Badge } from './Badge';

/** Status for the eye: done is green with a tick, cancelled is grey; planned shows nothing. */
export function VisitStatusBadge({ status }: { status: VisitDto['status'] }) {
  if (status === 'done') {
    return (
      <Badge tone="success">
        <Check aria-hidden="true" width="1em" height="1em" /> {VISIT_STATUS_LABELS.done}
      </Badge>
    );
  }
  if (status === 'cancelled') {
    return (
      <Badge tone="neutral">
        <Ban aria-hidden="true" width="1em" height="1em" /> {VISIT_STATUS_LABELS.cancelled}
      </Badge>
    );
  }
  return null;
}

export function UnpaidBadge({ visit }: { visit: Pick<VisitDto, 'status' | 'paymentStatus' | 'amountGrosze'> }) {
  if (visit.status !== 'done' || visit.paymentStatus === 'paid' || !visit.amountGrosze) return null;
  return <Badge tone="danger">Nieopłacona</Badge>;
}

export function visitTitle(v: Pick<VisitDto, 'serviceTypes'>): string {
  return v.serviceTypes.map((t) => t.name).join(', ') || 'Wizyta';
}

/** Colour key for `--user-<key>`: the person's colour, or "team" when more people go. */
export function visitColor(v: Pick<VisitDto, 'assignee' | 'assignees'>): UserColor | 'team' {
  return v.assignees.length > 1 ? 'team' : v.assignee.color;
}

export const visitPeople = (v: Pick<VisitDto, 'assignees'>) => v.assignees.map((u) => u.name).join(', ');

/** "10:00–11:30", or "10:00–13:00" for an arrival window (the work comes on top). */
export function visitTimeRange(v: Pick<VisitDto, 'startAt' | 'endAt' | 'arrivalWindowMinutes'>): string {
  if (!v.arrivalWindowMinutes) return timeRange(v.startAt, v.endAt);
  const start = local(v.startAt);
  return timeRange(v.startAt, start.plus({ minutes: v.arrivalWindowMinutes }).toISO()!);
}

/** Who/where in one line: client name and address, as available. */
export function visitClientName(v: Pick<VisitDto, 'client'>): string | null {
  if (!v.client) return null;
  return v.client.anonymized ? 'Klient usunięty' : v.client.name;
}
